import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  searchText: "",
};

const tasksSlice = createSlice({
  name: "tasks",
  initialState,
  reducers: {
    searchedByText: (state, action) => {
      state.searchText = action.payload;
    },
  },
});

export const { searchedByText } = tasksSlice.actions;
export default tasksSlice.reducer;
